import { surrogateEnabled } from '@/auth/authService';

export default class CASTokenStrategy {
  localStorageKey = surrogateEnabled() ? 'surrogate-id-token' : 'cas-id-token';

  getToken() {
    return localStorage.getItem(this.localStorageKey) || undefined;
  }

  setToken(token) {
    localStorage.setItem(this.localStorageKey, token);
  }

  removeToken() {
    localStorage.removeItem(this.localStorageKey);
  }
}



// WEBPACK FOOTER //
// ./src/auth/tokenStrategies/casTokenStrategy.js